import { LicenseManager, MenuModule, ClipboardModule, ExcelExportModule, MasterDetailModule, RangeSelectionModule, RowGroupingModule, ColumnsToolPanelModule, FiltersToolPanelModule } from 'ag-grid-enterprise'

import { ClientSideRowModelModule } from 'ag-grid-community'

export const AllModules = [
  MenuModule,
  LicenseManager,
  ClipboardModule,
  ExcelExportModule,
  MasterDetailModule,
  RangeSelectionModule,
  RowGroupingModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  ClientSideRowModelModule
]
